import FindLangKey from 'Global/Functions/FindLangKey/FindLangKey';
import React from 'react';

const useMatchCheckLang = (field) => {
  switch (field.Key) {
    case 'webAppgetFastNobat':
      return FindLangKey(
        'main-menu-settings-drawer-nobat-prefrences-show-fast-nobat'
      );
    case 'webAppshowTodayNobat':
      return FindLangKey(
        'main-menu-settings-drawer-nobat-prefrences-show-today-nobat'
      );

    case 'webAppshowTimeNobat':
      return FindLangKey(
        'main-menu-settings-drawer-nobat-prefrences-show-time-nobat'
      );

    case 'webAppshowHolidays':
      return FindLangKey(
        'main-menu-settings-drawer-nobat-prefrences-show-holidays'
      );
    case 'webAppcanRegister':
      return FindLangKey(
        'main-menu-settings-drawer-nobat-prefrences-can-register'
      );
  }
};

export default useMatchCheckLang;
